import styleInject from 'style-inject';
import { collectStyles } from '@lsg/ssr';

var reactStyles = " .lsgs-MS4xNC4w--theme{display:block;} .lsgs-MS4xNC4w--theme.lsgs-MS4xNC4w--theme__prevent-margin-overlap:before{content:\" \";display:block;height:0;padding-bottom:1px;margin-bottom:-1px;} .lsgs-MS4xNC4w--theme.lsgs-MS4xNC4w--theme__prevent-margin-overlap:after{content:\" \";display:block;height:0;padding-top:1px;margin-top:-1px;}";
var hostClass = "lsgs-MS4xNC4w--theme";
styleInject(reactStyles);
collectStyles(reactStyles);

export { hostClass, reactStyles };
